import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ContactAPI from "../../api/ContactAPI";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { FiPhone } from "react-icons/fi";
import { IoLocationOutline } from "react-icons/io5";
import { HiOutlineMail } from "react-icons/hi";
import { Tooltip } from "flowbite-react";
import { toImagePath } from "../../utils/globalFunctions";

function Complaint() {
  const { i18n } = useTranslation();
  const [complaint, setComplaint] = useState([]);
  const [document, setDocument] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const fetchComplaint = async () => {
    try {
      const response = await (i18n.language === 'en' ? ContactAPI.getContractComplaintEn() : ContactAPI.getContractComplaint());
      setComplaint(response.data);
      setDocument(response.data?.documentlist);
    } catch (error) {
      console.error("ContactAPI.getContractComplaint", error);
    }
  }

  useEffect(() => {
    fetchComplaint();
  }, [i18n.language]);

  const toggleIcon = () => {
    setIsOpen((prev) => !prev); // Toggle the state
  };

  return (
    <>
      <section className="banner bg-news-intro">
        <img
          className="banner-image w-full"
          src={"/images/contracts_bg/banner_complaint.jpeg"}
          alt="Hero Banner"
        />
        <div className="headline text-center">
          <h1 className="headline-title text-3xl md:text-6xl font-bold text-white">
            {complaint.title}
          </h1>
        </div>
      </section>
      <section className="content p-4 md:p-8 bg-gray-50">
        <div className="content-container box-news-container">
          <div className="content-header w-full">
            <div className="col-span-2 bg-white p-6 rounded-l-lg">
              <Tooltip content={complaint.title}>
              <div className="relative">
                <img
                  src={complaint.banner?.path ? toImagePath(complaint.banner.path) : "https://dummyimage.com/600x400"}
                  alt="CISA Cyber Hygiene"
                  className="w-full h-auto rounded-lg mb-4"
                />
              </div>
              </Tooltip>
              <div className="mt-10 text-center">
                <h2 className="text-md mb-4 text-black">
                  {complaint.invite}
                </h2>
                <div
                  className="mt-5 text-xl text-center text-black font-bold"
                  dangerouslySetInnerHTML={{ __html: complaint.lawofficehead ? complaint.lawofficehead.replace(/\n/g, "<br/>") : "" }}
                />
                {complaint.contactgroup &&
                  complaint.contactgroup.map((group, index) => (
                    <div key={index} className="mt-5 mb-6 w-full md:w-[60%] mx-auto text-start">
                      <div
                        key={index}
                        className="flex flex-col md:flex-row items-start space-y-3 md:space-y-0 md:space-x-3 mb-4"
                      >
                        {/* Main Icon */}
                        {(group.key.includes("ที่ตั้ง") ||
                          group.key.includes("โทรศัพท์") ||
                          group.key.includes("อีเมล")) && (
                            <div className={`flex items-center justify-center ${group.key.includes("ที่ตั้ง") ? "w-10 h-10 md:w-28 md:h-16" : "w-10 h-10 md:w-16 md:h-16"} rounded-md bg-[#E9EAF8]`}>
                              <div className="flex items-center justify-center w-6 h-6 md:w-12 md:h-12 rounded-full bg-blue-900">
                                {group.key.includes("ที่ตั้ง") && (
                                  <IoLocationOutline className="w-6 h-6 md:w-9 md:h-9 text-white" />
                                )}
                                {group.key.includes("โทรศัพท์") && (
                                  <FiPhone className="w-5 h-5 md:w-7 md:h-7 text-white" />
                                )}
                                {group.key.includes("อีเมล") && (
                                  <HiOutlineMail className="w-5 h-5 md:w-8 md:h-8 text-white" />
                                )}
                              </div>
                            </div>
                          )}

                        {/* Content */}
                        <div className="flex flex-col">
                          <h5 className="font-bold text-[#3D3D3D] text-[16px]">
                            {group.key}
                          </h5>
                          <h5 className="text-[#3D3D3D] text-[16px]">
                            {group.value}
                          </h5>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <button
                type="button"
                className="mt-5 flex items-center justify-between w-full p-5 font-medium rtl:text-right text-black border border-[#d6d7e1] focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-200 dark:border-grey-700 dark:text-black hover:bg-blue-100 dark:hover:bg-[#E9EAF8] gap-3 rounded-lg"
                onClick={toggleIcon}
              >
                <h1 className="text-left text-lg font-bold">{complaint.titledocuemnt}</h1>
                <span className="text-xl rtl:text-left text-blue-900" >
                  {isOpen ? <FiMinusCircle /> : <FiPlusCircle />}
                </span>
              </button>
              {isOpen && document.length > 0 && (
                <div className="p-5 border border-[#d6d7e1] dark:border-grey-700 bg-[#e9eaf7] rounded-lg">
                  {document.map((item, index) => (
                    <div
                      key={index}
                      className="flex cursor-pointer mb-5"
                      onClick={() => window.open(item.link, "_blank")}
                    >
                      <img
                        src="/images/icons/pdf.svg"
                        alt="PDF Icon"
                      />
                      <h5
                        className="ml-4 text-blue-900 dark:text-blue-900"
                      >
                        {item.title}
                      </h5>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <a
            href={complaint.fromlink}
            className="bg-red-600 text-white text-center font-bold py-2 px-4 rounded-full w-full md:w-1/3"
            target="_blank"
            rel="noreferrer"
          >
            {complaint.fromlinktitle}
          </a>
        </div>
      </section>
    </>
  )
}

export default Complaint;